// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--HFwFP","column":"_93444fe79c--column--aRrB7"};